import { useCallback, useState } from 'react'
import { filterActions } from '../store/filterSlice'
import { useAppSelector } from '../store/hooks'
import { store } from '../store'
import { Continent, Country } from '../types'

export default function LocationSelector() {
  const continents = useAppSelector((state) => state.config.continents)
  const [countries, setCountries] = useState<Country[]>([])

  const selectContinent = useCallback((continent: Continent) => {
    setCountries(continent.countries || []);
    updateMapLocation(continent);
  }, [])

  const updateMapLocation = useCallback(
    (hit: Country | Continent) => {
      const lat = hit.mapLat ?? 0
      const lng = hit.mapLong ?? 0
      const zoom = hit.mapZoom ?? 12
      if (lat === 0 || lng === 0) {
        return
      }
      store.dispatch(
        filterActions.setLocation({
          lat,
          lng,
          zoom
        })
      )
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'location_overview_select',
        location_name: hit.name
      });
    },
    []
  )

  return (
    <>
      <div className="mb-2 text-center">
        {continents.map((continent) => (
          <button
            key={continent.id}
            type="button"
            className="btn btn-outline-default btn-sm text-uppercase me-2 mt-1 continent-button" 
            onClick={() => selectContinent(continent)} 
          >{continent.name}</button>
        ))}
      </div>
      <div className="mb-3 countries-list text-center">
        {countries.map((country: Country) => (
          <button
            key={country.name}
            type="button"
            className="btn btn-sm me-2"
            onClick={() => updateMapLocation(country)}
          >{country.name}</button>
        ))}
      </div>
    </>
  )
}
